import { Fragment } from "react";
import Translate from "../Translate";

export const NsCard = ({children, title, subtitle, icon, getBottoniSx, getBottoniDx, onlyShowChildren=false}) => {
    return (
        <div className="card sost-card">
            <div className="card-body">
                {
                    !onlyShowChildren ?
                        <div className={"row card-title"}>
                            <div className={"col-md-3 text-start"}>
                                {
                                    getBottoniSx ? getBottoniSx() : ''
                                }
                            </div>
                            <div className={"col-md-6 text-center ns-card-title-container"}>
                                <h5 className="">
                                    <i className={icon}/>&nbsp;<Translate>{title}</Translate>
                                </h5>
                                {
                                    subtitle && subtitle !== '' ?
                                        <h6 className="card-subtitle mb-2 ns_text-muted text-center">
                                            <Translate>{subtitle}</Translate>
                                        </h6> : ''
                                }
                            </div>
                            <div className={"col-md-3 text-end"}>
                                {
                                    getBottoniDx ? getBottoniDx() : ''
                                }
                            </div>
                        </div>
                        : <Fragment/>
                }
                {children}
            </div>
        </div>

    )
}